import React from 'react';
import {
    withStyles,
    IconButton,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Grid,
    Typography,
    Avatar,
    Button,
    ButtonBase,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import AppData from '../../model/AppData';
import MBack from '../view/MBack';
import DeviceEventEmitter, { EventName } from '../../control/event';
import DefaultAvatarImg from '../../images/change/default_avatar.png';
import Apis from '../../network/Apis';



class SettingDialog extends React.Component {
    constructor(props) {
        super(props);
        this._onItemClick = this._onItemClick.bind(this);
        this._onUpdateAvatar = this._onUpdateAvatar.bind(this);
        this.state = {
            avatar: AppData.me.Pic,
        }
    }

    componentDidMount() {
        window.prevLoadingJs();
        DeviceEventEmitter.on(EventName.ON_UPLOAD_AVATAR, this._onUpdateAvatar, this);
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.ON_UPLOAD_AVATAR, this._onUpdateAvatar, this);
    }

    _onUpdateAvatar() {
        // window.history.back()
        this.setState({ avatar: AppData.me.Pic });
    }

    _showSelect() {
        window.handleHeadMdy((result) => {
            // result = result.replace("data:image/jpeg;base64,", '');
            this.updatePortrait(result);
        });
    }

    updatePortrait = async (file) => {
        let result = await Apis.encryptionUpdatePortrait(file, AppData.me.getUid());
        console.log('updatePortrait', result);
        if (result.code == 200) {
            this.setState({ Channels: result.data })
        }
    }

    _onItemClick(idx) {
        switch (idx) {
            case 0:
                this.props.history.push('/selfinfo')
                break;
            case 1:
                this.props.history.push('/safety')
                break;
            case 2:
                this.props.history.push('/realname')
                break;
            default:
                break;
        }
    }

    render() {
        const { classes } = this.props;
        const { avatar } = this.state;
        return (
            <MBack title='个人信息'>
                <Grid container justify='center' style={{ alignItems: 'center', justifyContent: 'flex-end', width: '100%', height: '30vw', backgroundColor: '#FFF' }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 13 }}>头像</Typography>} />
                    <Avatar onClick={() => this._showSelect()} className={classes.avatar} src={avatar} >
                        <img src={DefaultAvatarImg} alt='' style={{ right: 8, bottom: 8, position: 'absolute', width: 20, height: 20 }} ></img>
                    </Avatar>
                </Grid>
                <ListItem style={{ backgroundColor: '#fff', height: 50 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }}>账号</Typography>} />
                    <ListItemSecondaryAction>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete">
                            <Typography style={{ color: '#878787', fontSize: 14 }}>{AppData.me.Username}</Typography>
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem style={{ backgroundColor: '#fff', height: 50 }}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }}>ID</Typography>} />
                    <ListItemSecondaryAction>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete">
                            <Typography className={classes.listItta} style={{ color: '#878787', fontSize: 14 }}>{AppData.me.Uid}</Typography>
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem style={{ backgroundColor: '#fff', height: 50 }} button onClick={() => this._onItemClick(0)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }}>昵称</Typography>} />
                    <ListItemSecondaryAction style={{ right: 0 }}>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete" onClick={() => this._onItemClick(0)}>
                            <Typography style={{ color: '#878787', fontSize: 14 }}>{AppData.me.Username}</Typography>
                            <ChevronRightOutlinedIcon style={{ color: '#E2E2E2', fontSize: 20 }} />
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
                <div className={classes.divider} />
                <ListItem style={{ backgroundColor: '#fff', height: 55 }} button onClick={() => this._onItemClick(2)}>
                    <ListItemText primary={<Typography style={{ color: '#0D0D0D', fontSize: 14 }} >实名认证</Typography>} />
                    <ListItemText primary={<Typography style={{ color: '#878787', fontSize: 8, marginRight: 80 }}>(与主播互动需要实名认证哦)</Typography>} />
                    <ListItemSecondaryAction style={{ right: 8 }}>
                        <ButtonBase className={classes.listItta} edge="end" aria-label="delete" onClick={() => this._onItemClick(2)}>
                            <Typography style={{ color: '#0D0D0D', fontSize: 14 }}>{'去认证'}</Typography>
                        </ButtonBase>
                    </ListItemSecondaryAction>
                </ListItem>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    icon: {
        color: '#E2E2E2',
        fontSize: 20,
    },
    avatar: {
        width: 60,
        height: 60,
        color: '#fff',
        backgroundSize: 'cover',
        backgroundImage: `url(${DefaultAvatarImg})`,
        marginRight: 16,
    },
    divider: {
        height: 8,
        padding: theme.spacing(0, 1.5, 0, 1.5),
        backgroundColor: '#F0F0F0',
    },
    listItta: {
        padding: theme.spacing(0, 1, 0, 0),
        textAlign: 'right',
    }

}))(SettingDialog));